"use client";

import { createContext, type ReactNode, use } from "react";
import type { PlpFilterGroupConfig } from "@/lib/contentful/filterGroups";

const PlpFilterGroupsContext = createContext<PlpFilterGroupConfig[] | null>(null);

interface Props {
  groups: PlpFilterGroupConfig[];
  children: ReactNode;
}

export function PlpFilterGroupsProvider({ groups, children }: Props) {
  return <PlpFilterGroupsContext value={groups}>{children}</PlpFilterGroupsContext>;
}

export function useFilterGroups(): PlpFilterGroupConfig[] {
  const groups = use(PlpFilterGroupsContext);
  if (groups === null) {
    throw new Error("useFilterGroups must be used within a PlpFilterGroupsProvider");
  }
  return groups;
}
